import { FC, useState } from "react";
import { useSubject } from "../../../util/useSubject";
import {
  AttachmentDialog,
  AttachmentDialogProps,
} from "../attachment-dialog/AttachmentDialog";
import {
  attachmentDialogClosed,
  attachmentDialogOpened,
} from "../attachment-dialog/AttachmentDialogService";

/**
 * This component is used to facilitate spawning new react dialogs
 * from the legacy angularjs application.
 */
export const LegacyDialogConnector: FC = () => {
  const [renderAttachmentDialog, setRenderAttachmentDialog] = useState(false);
  const [attachmentDialogProps, setAttachmentDialogProps] =
    useState<AttachmentDialogProps | null>(null);

  useSubject(attachmentDialogOpened, (openOptions) => {
    setAttachmentDialogProps({ ...openOptions, open: true });
    setRenderAttachmentDialog(true);
  });

  // When the dialog isn't being shown, we don't render it at all
  // to forcibly reset the state of the dialog
  return renderAttachmentDialog && attachmentDialogProps ? (
    <AttachmentDialog
      {...attachmentDialogProps}
      TransitionProps={{
        onExited: () => {
          setRenderAttachmentDialog(false);
          attachmentDialogClosed.next({});
        },
      }}
      onClose={() => {
        setAttachmentDialogProps((props) => {
          if (!props) {
            return props;
          }
          return { ...props, open: false };
        });
      }}
    />
  ) : (
    <></>
  );
};
